export enum ConnectionStatus {
  ok = 'ok',
  unreachable = 'unreachable',
  invalid_credentials = 'invalid_credentials',
}
